import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button as MuiButton,
  IconButton,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import WarningIcon from "@mui/icons-material/Warning";
import CloseIcon from "@mui/icons-material/Close";
import { closeModal } from "../../redux/reducers/dialog";
import TextView from "../TextView";
import Button from "../Button";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  ".MuiBackdrop-root": {
    backgroundColor: "rgba(0, 0, 0, 0.8)",
  },
  ".MuiPaper-root": {
    padding: "15px 8px",
    border: "1px solid #E1E1E1",
    borderRadius: 8,
  },
}));

const DeleteModal = () => {
  const dispatch = useDispatch();
  const { isOpen, title, subtitle, onCancel, onConfirm } = useSelector(
    (state) => state.deleteDialog
  );

  const handleCancel = () => {
    if (onCancel) onCancel();
    dispatch(closeModal());
  };

  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    dispatch(closeModal());
  };

  return (
    <StyledDialog
      open={isOpen}
      onClose={handleCancel}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <DialogTitle>
        <TextView variant="title">
          <WarningIcon color="warning" />{" "}
          <span style={{ marginLeft: "10px" }}>{title}</span>
        </TextView>
        <IconButton
          aria-label="close"
          onClick={handleCancel}
          sx={{
            position: "absolute",
            right: 8,
            top: 20,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <TextView variant="subtitle">{subtitle}</TextView>
        <TextView variant="subtitle">This action cannot be undone.</TextView>
      </DialogContent>
      <DialogActions>
        <Button
          style={{ width: 120 }}
          variant={"secondary"}
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          style={{ width: 100, backgroundColor: "#822B86" }}
        >
          Confirm
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default DeleteModal;
